import CommentsFields from "./fields";
import CommentsForms from "./forms";
import CommentsHelpers from "./helpers";


const Comments = {
    Fields: CommentsFields,
    Forms: CommentsForms,
    Helpers: CommentsHelpers,
};

export default Comments;
